import { makeStyles, tokens } from "@fluentui/react-components";
/**
 * Styles for the ToastContent component
 */ export const useToastContentStyles = makeStyles({
    /**
     * Dismiss button styling for the inverted toast surface.
     */ dismissButton: {
        paddingTop: "0px",
        paddingBottom: "0px",
        color: "inherit !important",
        // The toast renders with an inverted (dark) surface, so the default dark focus outline
        // (colorStrokeFocus2 = #000000) has <3:1 contrast against the background. Override the
        // focus stroke with the inverted (light) foreground so the keyboard focus indicator meets
        // the 3:1 non-text contrast requirement (MAS 1.4.11).
        "--colorStrokeFocus2": tokens.colorNeutralForegroundInverted
    }
});
